import(/* webpackMode: "eager" */ "/codebuild/output/src1834264613/src/skop-manage/node_modules/next/dist/client/app-dir/link.js");
